import React, { useEffect, useState } from "react";
import usePaginationHook from "../../../hooks/usePaginationHook";
import useTxnFilterHook from "../../../hooks/useTxnFilterHook";
import dayjs from "dayjs";
import { getSavedPaymentAccounts } from "../../../redux/user/actions";
import QueryString from "qs";
import PaginationCardNew from "../PaginationCardNew";
import { DefaultDateFormat, PaymentAccountType } from "../../../config/const";
// import TxnFilters from "../Transactions/Filters";
import { AppLoader } from "../Ui/AppLoader";
import { Table } from "react-bootstrap";

const SelectPaymentAccount = ({ setPaymentAccountId, paymentAccountId }) => {
  const pagination = usePaginationHook();
  const filtersHook = useTxnFilterHook({
    from: dayjs().subtract(1, "year").format("YYYY-MM-DD"),
    to: dayjs().add(1, "day").format("YYYY-MM-DD"),
  });
  const [paymentAccounts, setPaymentAccounts] = useState({
    count: 0,
    pagesize: 15,
    results: [],
  });
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    fetchPaymentAccounts();
  }, [
    filtersHook.filters.from,
    filtersHook.filters.to,
    pagination.apiParams.pagesize,
    pagination.apiParams?.skip,
  ]);

  const fetchPaymentAccounts = async () => {
    const object = {
      startdate: new Date(filtersHook.filters.from),
      enddate: new Date(filtersHook.filters.to),
      type: PaymentAccountType.Bank,
      pagesize: pagination.apiParams?.pagesize,
      skip: pagination.apiParams?.skip,
    };
    const query = QueryString.stringify(object);
    setIsFetching(true);
    const response = await getSavedPaymentAccounts(query);
    setIsFetching(false);
    if (response && "data" in response) {
      setPaymentAccounts(response?.data?.data);
    }
  };

  const handleAccountClick = (id = null) => {
    if (paymentAccountId && paymentAccountId === id) {
      setPaymentAccountId(null);
      return;
    }
    setPaymentAccountId(id);
    return;
  };

  return (
    <div className="data-info">
      {/* <TxnFilters
        filtersHook={filtersHook}
        showSearch={false}
        resetValues={{
          from: dayjs().subtract(1, "year").format("YYYY-MM-DD"),
          to: dayjs().add(1, "day").format("YYYY-MM-DD"),
        }}
      /> */}
      {isFetching ? (
        <AppLoader text={"Fetching payment accounts"} />
      ) : paymentAccounts?.results?.length > 0 ? (
        <div className="table-responsive table-wrapper">
          <Table responsive borderless className="custom-table align-middle">
            <thead>
              <tr>
                <th></th>
                <th>Id</th>
                <th>Account Name</th>
                <th>Account Number</th>
                <th>Created At</th>
              </tr>
            </thead>

            <tbody>
              {paymentAccounts?.results?.map((account, index) => (
                <tr
                  key={index}
                  onClick={() => handleAccountClick(account?.id)}
                  role="button"
                >
                  <td>
                    <input
                      role="button"
                      type="checkbox"
                      checked={Boolean(
                        paymentAccountId && account.id === paymentAccountId,
                      )}
                    />
                  </td>
                  <td>{index + 1}</td>
                  <td>{account?.name || "-"}</td>
                  <td className="status">{account?.hint}</td>
                  <td>{dayjs(account?.createdAt).format(DefaultDateFormat)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="d-flex justify-content-center">
          Nothing here just yet — your payment accounts will appear here once
          available
        </div>
      )}

      <div className="border-t px-3 pb-5">
        <PaginationCardNew
          pagination={pagination}
          count={paymentAccounts.count}
        />
      </div>
    </div>
  );
};
export default SelectPaymentAccount;
